import React, { useState } from 'react'
import './content.scss'
// import { graphql, useStaticQuery } from 'gatsby';
import Breadcrumb from '../../../shared/components/atoms/breadcrumb/breadcrumb';
import HeaderSearcher from '../../molecules/header-searcher/header-searcher';
import ResultSearcher from '../../molecules/result-searcher/result-searcher';


const Content = props => {
  const [itemsFilter, setItemsFilter] = useState([])
  const [valueSerched, setSerched] = useState('')
  const [numArticles, setnumArticles] = useState(6);

  return (
    <div className="f-content">
      <HeaderSearcher contennInfo={props.dataSearch} mobile={props.mobile} setItemsFilter={setItemsFilter} setSerched={setSerched} setnumArticles={setnumArticles} />
      <div className="f-breadcrum-position">
        <Breadcrumb
          mobile={props.mobile}
        />
      </div>
      <ResultSearcher result={itemsFilter} valueSerched={valueSerched} numArticles={numArticles} setnumArticles={setnumArticles} />
    </div>
  )
}
export default Content;
